// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__zzjts","disabled":"FileBtn_disabled__3fyT9","warn":"FileBtn_warn__3cFiY","fade":"FileBtn_fade__3Zp68"};